module.exports = __webpack_public_path__ + "img/partner_13.32e07ef8.png";